/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenancePricingCombinationResponseDto } from './PartnerMaintenancePricingCombinationResponseDto';
import {
    PartnerMaintenancePricingCombinationResponseDtoFromJSON,
    PartnerMaintenancePricingCombinationResponseDtoFromJSONTyped,
    PartnerMaintenancePricingCombinationResponseDtoToJSON,
    PartnerMaintenancePricingCombinationResponseDtoToJSONTyped,
} from './PartnerMaintenancePricingCombinationResponseDto';
import type { PartnerMaintenanceTimerResponseDto } from './PartnerMaintenanceTimerResponseDto';
import {
    PartnerMaintenanceTimerResponseDtoFromJSON,
    PartnerMaintenanceTimerResponseDtoFromJSONTyped,
    PartnerMaintenanceTimerResponseDtoToJSON,
    PartnerMaintenanceTimerResponseDtoToJSONTyped,
} from './PartnerMaintenanceTimerResponseDto';

/**
 * 
 * @export
 * @interface PartnerMaintenanceLevelResponseDto
 */
export interface PartnerMaintenanceLevelResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceLevelResponseDto
     */
    code: PartnerMaintenanceLevelResponseDtoCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceLevelResponseDto
     */
    penaltyClauseText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenanceLevelResponseDto
     */
    penaltyAmount?: number | null;
    /**
     * 
     * @type {Array<PartnerMaintenanceTimerResponseDto>}
     * @memberof PartnerMaintenanceLevelResponseDto
     */
    timers: Array<PartnerMaintenanceTimerResponseDto>;
    /**
     * 
     * @type {Array<PartnerMaintenancePricingCombinationResponseDto>}
     * @memberof PartnerMaintenanceLevelResponseDto
     */
    pricingCombinations: Array<PartnerMaintenancePricingCombinationResponseDto>;
}


/**
 * @export
 */
export const PartnerMaintenanceLevelResponseDtoCodeEnum = {
    N1: 'N1',
    N2: 'N2',
    N3: 'N3',
    N4: 'N4',
    N5: 'N5',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
} as const;
export type PartnerMaintenanceLevelResponseDtoCodeEnum = typeof PartnerMaintenanceLevelResponseDtoCodeEnum[keyof typeof PartnerMaintenanceLevelResponseDtoCodeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceLevelResponseDto interface.
 */
export function instanceOfPartnerMaintenanceLevelResponseDto(value: object): value is PartnerMaintenanceLevelResponseDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('timers' in value) || value['timers'] === undefined) return false;
    if (!('pricingCombinations' in value) || value['pricingCombinations'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceLevelResponseDtoFromJSON(json: any): PartnerMaintenanceLevelResponseDto {
    return PartnerMaintenanceLevelResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceLevelResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceLevelResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'penaltyClauseText': json['penaltyClauseText'] == null ? undefined : json['penaltyClauseText'],
        'penaltyAmount': json['penaltyAmount'] == null ? undefined : json['penaltyAmount'],
        'timers': ((json['timers'] as Array<any>).map(PartnerMaintenanceTimerResponseDtoFromJSON)),
        'pricingCombinations': ((json['pricingCombinations'] as Array<any>).map(PartnerMaintenancePricingCombinationResponseDtoFromJSON)),
    };
}

export function PartnerMaintenanceLevelResponseDtoToJSON(json: any): PartnerMaintenanceLevelResponseDto {
    return PartnerMaintenanceLevelResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceLevelResponseDtoToJSONTyped(value?: PartnerMaintenanceLevelResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'penaltyClauseText': value['penaltyClauseText'],
        'penaltyAmount': value['penaltyAmount'],
        'timers': ((value['timers'] as Array<any>).map(PartnerMaintenanceTimerResponseDtoToJSON)),
        'pricingCombinations': ((value['pricingCombinations'] as Array<any>).map(PartnerMaintenancePricingCombinationResponseDtoToJSON)),
    };
}

